// 组件对象，大写
import headerTit from './headerTit.vue'
export default headerTit
